import { ModalContextProvider } from 'utils/contexts/modal/provider';
import { TemplateHistoryContextProvider } from '../context/TemplateHistoryContextProvider';
import { TemplateHistory } from './TemplateHistory';

export const TemplateHistoryPage = () => {
  return (
    <ModalContextProvider>
      <TemplateHistoryContextProvider>
        <TemplateHistory />
      </TemplateHistoryContextProvider>
    </ModalContextProvider>
  );
};
